import React, { useEffect, useState } from 'react';
import { Editor } from 'primereact/editor';
import { Modal, ModalBody } from "react-bootstrap";
import { sanitize } from 'dompurify';
import AlertMessagePopUpModal from '../PopUp/AlertMessagePopUpModal';

export default function MyEditor(props) {
    const [text, setText] = useState('');
    const [selectedSummary, setSelectedSummary] = useState('');
    const [editSummary, setEditSummary] = useState(false);
    const [summaryId, setSummaryId] = useState();
    const [isSummary, setIsSummay] = useState(false);
    const [isNotes, setIsNotes] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState('');
    const [alertMessageContent, setalertMessageContent] = useState("")
    const [alertMessageModelColor, setalertMessageModelColor] = useState("")
    const [alertMessageShowModal, setalertMessageShowModal] = useState(false)

    useEffect(() => {
        if (props.summaryId) {
            setSummaryId(props.summaryId)
        }
        if (props.isSummary) {
            setIsSummay(props.isSummary)
        }
        if (props.isNotes) {
            setIsNotes(props.isNotes)
        }
    }, [])

    useEffect(() => {
        setSelectedSummary(props.selectedSummary)
    }, [props.selectedSummary])

    useEffect(() => {
        setSelectedQuestion(props.selectedQuestion)
    }, [props.selectedQuestion])

    useEffect(() => {
        if (props.isEditSourceText) {
            handleEdit();
        }
    }, [props.isEditSourceText])

    const handleEdit = () => {
        setEditSummary(true)
    }
    const handleApply = async () => {
        if (isNotes) {
            updateNotes()
        } else if (isSummary) {
            handleApplySummaryChanges()
        }
    }
    const handleDelete = async () => {
        if (isNotes) {
            deleteNotes();
        } else if (isSummary) {
            deleteSummary();
        }
    }
    const handleApplySummaryChanges = async () => {
        if(selectedSummary){
        props.updateSummary(summaryId, selectedSummary)
        }else{
            errorAlertMessage('Selected summary cannot be empty.')
        }
    }
    const deleteSummary = () => {
        props.deleteSummary(summaryId)
        props.handleClose();
    }
    const handleCloseEdit = () => {
        // setEditSummary(false);
        // if(!isApply){
        // setSelectedSummary(props.selectedSummary)
        // }
        // setIsApply(false)
        props.handleClose()
    }
    const handleAddToSummary = () => {
        if(selectedSummary){
        props.handleAddToSummary(selectedSummary, selectedQuestion);
        props.handleClose()
        }else{
            errorAlertMessage('Selected summary cannot be empty.')
        }
    }
    const handleAddToSource = () => {
        if(selectedSummary){
        props.handleAddToSource(selectedSummary);
        props.handleClose();
        }else{
            errorAlertMessage('Selected summary cannot be empty.')
        }
    }
    const handeAddToNotes = () => {
        if(selectedSummary){
        props.handeAddToNotes(selectedSummary);
        props.handleClose();
        }else{
            errorAlertMessage('Selected summary cannot be empty.')
        }
    }
    const updateNotes = () => {
        if(selectedSummary){
        props.handleUpdateNotes(summaryId, selectedSummary);
        props.handleClose();
        }else{
            errorAlertMessage('Selected summary cannot be empty.')
        }
    }
    const deleteNotes = () => {
        props.handleDeleteNotes(summaryId);
        props.handleClose();
    }
    
    const errorAlertMessage = (message) => {
        setalertMessageContent(message);
        setalertMessageModelColor("#de1327");
        setalertMessageShowModal(true)
    }
    const closeAlertMessage = () => {
        setalertMessageContent("");
        setalertMessageModelColor("");
        setalertMessageShowModal(false);

    }
    return (
        <>
            <Modal
                show={props.showModal}
                size="xl md sm xs"
                centered
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="popup-transition"
                scrollable={true}
                className='notebook-popup-ai'
            >
                <Modal.Header>
                    <div style={{ display: 'flex', gap: '13px', color: '#EB1700', alignItems: 'center' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><g clip-path="url(#clip0_309_9262)"><path d="M12.8334 10.0833H7.33341M9.16675 13.75H7.33341M14.6667 6.41666H7.33341M18.3334 6.23333V15.7667C18.3334 17.3068 18.3334 18.0769 18.0337 18.6651C17.77 19.1826 17.3493 19.6033 16.8319 19.8669C16.2436 20.1667 15.4736 20.1667 13.9334 20.1667H8.06675C6.5266 20.1667 5.75653 20.1667 5.16827 19.8669C4.65083 19.6033 4.23013 19.1826 3.96648 18.6651C3.66675 18.0769 3.66675 17.3068 3.66675 15.7667V6.23333C3.66675 4.69318 3.66675 3.92311 3.96648 3.33485C4.23013 2.81741 4.65083 2.39671 5.16827 2.13306C5.75653 1.83333 6.5266 1.83333 8.06675 1.83333H13.9334C15.4736 1.83333 16.2436 1.83333 16.8319 2.13306C17.3493 2.39671 17.77 2.81741 18.0337 3.33485C18.3334 3.92311 18.3334 4.69318 18.3334 6.23333Z" stroke="#EB1700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_309_9262"><rect width="22" height="22" fill="white"></rect></clipPath></defs></svg>
                        <div>{props.selectedNotebookName}</div>
                    </div>
                    <div style={{ cursor: 'pointer' }} onClick={() => props.handleClose()}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '80vh' }}>
                    {(!editSummary) ? <>
                        {(selectedQuestion) && <div className='summary-panel-question'>{selectedQuestion}</div>}
                        <div style={{ marginTop: '13px' }} dangerouslySetInnerHTML={{ __html: sanitize(selectedSummary) }} /></>
                        : <>
                            <Editor
                                value={selectedSummary}
                                onTextChange={(e) => setSelectedSummary(e.htmlValue)}
                                style={{ height: '320px' }}
                            />
                            {(!props.isEditSourceText) ? <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ width: "100%", height: "100%", position: "relative" }}>
                                    <div className='toolbar-conc'>
                                        Tip: Use the toolbar above to format your text</div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', gap: '4px' }}>
                                    <div className='dlt-conc' aria-label='Delete' onClick={handleDelete}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M5.99986 2H9.99972M2 4H13.9996M12.6663 4L12.1988 11.0129C12.1286 12.065 12.0936 12.5911 11.8663 12.99C11.6663 13.3412 11.3645 13.6235 11.0008 13.7998C10.5877 14 10.0604 14 9.00598 14H6.99359C5.93913 14 5.4119 14 4.99879 13.7998C4.63508 13.6235 4.33331 13.3412 4.13325 12.99C3.90601 12.5911 3.87094 12.065 3.80079 11.0129L3.33329 4M6.6665 7V10.3333M9.33308 7V10.3333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    {/* <div className='save-summary-notes-button' aria-label='Add to Source' onClick={handleAddToSource}>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_1514_5528)">
                                                    <path d="M9.33294 1.51294V4.26663C9.33294 4.64 9.33294 4.82669 9.4056 4.96929C9.46951 5.09473 9.57149 5.19672 9.69693 5.26064C9.83953 5.3333 10.0262 5.3333 10.3996 5.3333H13.1532M9.33294 11.3333H5.33308M10.6662 8.66658H5.33308M13.3328 6.65873V11.4666C13.3328 12.5867 13.3328 13.1467 13.1148 13.5746C12.9231 13.9509 12.6171 14.2569 12.2408 14.4486C11.813 14.6666 11.253 14.6666 10.1329 14.6666H5.86639C4.74633 14.6666 4.18629 14.6666 3.75848 14.4486C3.38217 14.2569 3.07622 13.9509 2.88448 13.5746C2.6665 13.1467 2.6665 12.5867 2.6665 11.4666V4.53325C2.6665 3.41315 2.6665 2.85309 2.88448 2.42527C3.07622 2.04895 3.38217 1.74299 3.75848 1.55124C4.18629 1.33325 4.74633 1.33325 5.86639 1.33325H8.0075C8.49666 1.33325 8.74124 1.33325 8.97141 1.38851C9.17548 1.43751 9.37056 1.51831 9.5495 1.62797C9.75132 1.75166 9.92427 1.92461 10.2702 2.27051L12.3956 4.39599C12.7415 4.7419 12.9144 4.91485 13.0381 5.11668C13.1477 5.29563 13.2285 5.49072 13.2775 5.69479C13.3328 5.92496 13.3328 6.16955 13.3328 6.65873Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1514_5528">
                                                        <rect width="15.9994" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                        <div>
                                            Add to Source
                                        </div>
                                    </div> */}
                                    <div className='save-summary-notes-button' aria-label='Add to Summary' onClick={handleAddToSummary}>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M14.3694 6.72988L13.7495 6.10988L13.6645 6.02488L11.0046 8.68488L9.50961 7.18988L12.1695 4.52988L11.8195 4.17988L11.5095 3.86988L11.4595 3.81988L8.79964 6.47988L7.32469 4.99988L9.98459 2.33988L9.8946 2.24988L9.27462 1.62988L6.21473 4.68988L6.13473 4.80488L1.63489 13.6599L2.33986 14.3649L11.2096 9.85988L11.3245 9.77988L14.3694 6.72988ZM6.25973 11.2499C5.68975 11.5399 5.33976 11.7149 4.93477 11.3099L4.76978 11.1449L4.59978 10.9799C4.27979 10.6549 4.45979 10.3149 4.74478 9.73988L6.73471 5.82988L10.1746 9.26988L6.25973 11.2499Z" fill="black" />
                                            </svg>
                                        </span>
                                        <div>
                                            Save to Summaries
                                        </div>
                                    </div>
                                    <div className='save-summary-notes-button' aria-label='Add to Notes' onClick={handeAddToNotes}>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_1514_7622)">
                                                    <path d="M9.33306 7.33325H5.3332M6.66649 9.99992H5.3332M10.6663 4.66659H5.3332M13.3329 4.53325V11.4666C13.3329 12.5867 13.3329 13.1467 13.1149 13.5746C12.9232 13.9509 12.6172 14.2569 12.2409 14.4486C11.8131 14.6666 11.2531 14.6666 10.133 14.6666H5.86651C4.74645 14.6666 4.18641 14.6666 3.75861 14.4486C3.3823 14.2569 3.07635 13.9509 2.88461 13.5746C2.66663 13.1467 2.66663 12.5867 2.66663 11.4666V4.53325C2.66663 3.41315 2.66663 2.85309 2.88461 2.42527C3.07635 2.04895 3.3823 1.74299 3.75861 1.55124C4.18641 1.33325 4.74645 1.33325 5.86651 1.33325H10.133C11.2531 1.33325 11.8131 1.33325 12.2409 1.55124C12.6172 1.74299 12.9232 2.04895 13.1149 2.42527C13.3329 2.85309 13.3329 3.41315 13.3329 4.53325Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1514_7622">
                                                        <rect width="15.9994" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                        <div>
                                            Save to Notes
                                        </div>
                                    </div>
                                </div>
                            </div> : <></>}
                        </>}
                </Modal.Body>
                <Modal.Footer>
                    {(!editSummary) && <>
                        <button className='source-btn btn-hover' style={{ background: 'none', borderColor: '#FFF', width: 'auto' }} type="button" aria-label="Delete Summary" onClick={handleDelete}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M5.99986 2H9.99972M2 4H13.9996M12.6663 4L12.1988 11.0129C12.1286 12.065 12.0936 12.5911 11.8663 12.99C11.6663 13.3412 11.3645 13.6235 11.0008 13.7998C10.5877 14 10.0604 14 9.00598 14H6.99359C5.93913 14 5.4119 14 4.99879 13.7998C4.63508 13.6235 4.33331 13.3412 4.13325 12.99C3.90601 12.5911 3.87094 12.065 3.80079 11.0129L3.33329 4M6.6665 7V10.3333M9.33308 7V10.3333" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        <button className='source-btn btn-hover' style={{ background: 'none', borderColor: '#FFF', width: 'auto' }} type="button" aria-label="Re-write" onClick={handleEdit}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(#clip0_595_669)"><path d="M1.91719 12.0771C1.94782 11.8014 1.96313 11.6636 2.00483 11.5348C2.04183 11.4205 2.09411 11.3117 2.16024 11.2114C2.23479 11.0984 2.33284 11.0003 2.52896 10.8042L11.3328 2.00001C12.0692 1.26363 13.2631 1.26363 13.9994 2.00001C14.7358 2.73639 14.7358 3.9303 13.9994 4.66668L5.19553 13.4709C4.99942 13.667 4.90136 13.765 4.78832 13.8396C4.68803 13.9057 4.57926 13.958 4.46497 13.995C4.33615 14.0367 4.19832 14.052 3.92267 14.0826L1.6665 14.3333L1.91719 12.0771Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_595_669"><rect width="15.9994" height="16" rx="4" fill="white"></rect></clipPath></defs></svg>
                        </button>
                        <div className='save-summary-notes-button' aria-label='Add to Source' onClick={handleAddToSource}>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_1514_5528)">
                                        <path d="M9.33294 1.51294V4.26663C9.33294 4.64 9.33294 4.82669 9.4056 4.96929C9.46951 5.09473 9.57149 5.19672 9.69693 5.26064C9.83953 5.3333 10.0262 5.3333 10.3996 5.3333H13.1532M9.33294 11.3333H5.33308M10.6662 8.66658H5.33308M13.3328 6.65873V11.4666C13.3328 12.5867 13.3328 13.1467 13.1148 13.5746C12.9231 13.9509 12.6171 14.2569 12.2408 14.4486C11.813 14.6666 11.253 14.6666 10.1329 14.6666H5.86639C4.74633 14.6666 4.18629 14.6666 3.75848 14.4486C3.38217 14.2569 3.07622 13.9509 2.88448 13.5746C2.6665 13.1467 2.6665 12.5867 2.6665 11.4666V4.53325C2.6665 3.41315 2.6665 2.85309 2.88448 2.42527C3.07622 2.04895 3.38217 1.74299 3.75848 1.55124C4.18629 1.33325 4.74633 1.33325 5.86639 1.33325H8.0075C8.49666 1.33325 8.74124 1.33325 8.97141 1.38851C9.17548 1.43751 9.37056 1.51831 9.5495 1.62797C9.75132 1.75166 9.92427 1.92461 10.2702 2.27051L12.3956 4.39599C12.7415 4.7419 12.9144 4.91485 13.0381 5.11668C13.1477 5.29563 13.2285 5.49072 13.2775 5.69479C13.3328 5.92496 13.3328 6.16955 13.3328 6.65873Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1514_5528">
                                            <rect width="15.9994" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            <div>
                                Add to Source
                            </div>
                        </div></>}
                    {(editSummary) && <>
                        <div className={"GenAIAuthoring-div-label pd-none create-draft"} style={{ fontWeight: '400', fontSize: '16px' }} onClick={handleCloseEdit}>Cancel</div>
                        <div className={"GenAIAuthoring-div-label pd-none create-draft"} style={{ fontWeight: '400', fontSize: '16px' }} onClick={handleApply}>Apply Changes</div>
                    </>}
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={closeAlertMessage} />}
                </Modal.Footer>
            </Modal>
        </>
    );
}